<template>
  <section id="Categoria" class="categorias">
    <h2 class="titulo">🖨️ Categorías de Impresoras</h2>

    <div class="grid-categorias">
      <div
        v-for="(categoria, index) in categorias"
        :key="index"
        class="card-categoria"
      >
        <img :src="categoria.icono" :alt="categoria.titulo" class="icono" />
        <h3 class="card-titulo">{{ categoria.titulo }}</h3>
        <p class="card-descripcion">{{ categoria.descripcion }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategoriasImpresoras',
  data() {
    return {
      categorias: [
        {
          titulo: 'Diagnóstico Técnico',
          icono: require('@/assets/icons/diagnostico.png'),
          descripcion: 'Identificación de fallas, análisis de errores y evaluación de rendimiento de impresoras.'
        },
        {
          titulo: 'Mantenimiento Preventivo',
          icono: require('@/assets/icons/maintenance.png'),
          descripcion: 'Limpieza interna, calibración y revisión periódica para prolongar la vida útil del equipo.'
        },
        {
          titulo: 'Instalación y Configuración',
          icono: require('@/assets/icons/instalacion.png'),
          descripcion: 'Instalación de impresoras en red, configuración de drivers y ajustes personalizados.'
        },
        {
          titulo: 'Reparación de Impresoras',
          icono: require('@/assets/icons/impresora.png'),
          descripcion: 'Solución de problemas mecánicos, eléctricos y de software en impresoras domésticas y empresariales.'
        },
        {
          titulo: 'Recarga de Cartuchos',
          icono: require('@/assets/icons/recarga.png'),
          descripcion: 'Recarga profesional de cartuchos de tinta y tóner, con pruebas de calidad y rendimiento.'
        },
        {
          titulo: 'Optimización Empresarial',
          icono: require('@/assets/icons/empresa.png'),
          descripcion: 'Soluciones de impresión para oficinas, reducción de costos y gestión eficiente de recursos.'
        },
        {
  titulo: 'Soluciones HP Empresariales',
  icono: require('@/assets/icons/hp-5.svg'),
  descripcion: 'Servicios técnicos y estratégicos para impresoras HP: instalación, mantenimiento, optimización y gestión eficiente en entornos corporativos.'
},
{
  titulo: 'Soporte Técnico Samsung',
  icono: require('@/assets/icons/samsung.svg'),
  descripcion: 'Diagnóstico, reparación y configuración profesional de impresoras Samsung, con soluciones adaptadas a oficinas y empresas.'
},
{
  titulo: 'Soluciones Canon Empresariales',
  icono: require('@/assets/icons/canon.svg'),
  descripcion: 'Instalación, mantenimiento y configuración experta de impresoras Canon, con enfoque en eficiencia operativa y rendimiento óptimo en entornos corporativos.'
},
{
  titulo: 'Soluciones Ricoh Empresariales',
  icono: require('@/assets/icons/ricoh.svg'),
  descripcion: 'Servicios especializados para impresoras Ricoh: instalación en red, mantenimiento profesional, configuración avanzada y optimización para oficinas modernas.'
},
{
  titulo: 'Soluciones Xerox Profesionales',
  icono: require('@/assets/icons/xerox.svg'),
  descripcion: 'Servicios técnicos para impresoras Xerox: instalación empresarial, mantenimiento especializado, configuración de red y optimización para flujos de trabajo exigentes.'
},
{
  titulo: 'Soluciones Kyocera Corporativas',
  icono: require('@/assets/icons/kyocera.svg'),
  descripcion: 'Servicios técnicos para equipos Kyocera: instalación en red, mantenimiento especializado, configuración de impresión segura y optimización para entornos empresariales exigentes.'
}
      ]
    }
  }
}
</script>

<style scoped>
.categorias {
  background: url('@/assets/Img/Banners/impresora-profesional.jpg') no-repeat center center;
  background-size: cover;
  padding: 3rem 2rem;
  color: #fff;
  text-align: center;
}

.titulo {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  animation: fadeInDown 1s ease-in-out;
}

.grid-categorias {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: auto;
}

.card-categoria {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  animation: fadeInUp 1s ease forwards;
}

.card-categoria:nth-child(n) {
  animation-delay: calc(0.1s * var(--i));
}

.card-categoria:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 242, 255, 0.4);
}

.icono {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.card-categoria:hover .icono {
  transform: scale(1.2) rotate(5deg);
}

.card-titulo {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
}

.card-descripcion {
  font-size: 0.95rem;
  text-align: center;
  line-height: 1.4;
}

/* Animaciones */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
